export function formatCategories (categories) {
  categories.forEach(
    category => {
      category.selected = true
      category.open = true
      category.subCats.forEach(
        subcat => {
          subcat.selected = true
          subcat.open = false
          subcat.types.forEach(
            type => {
              type.selected = true
            }
          )
        }
      )
    }
  )
}
export function formatCommercialCategory (category) {
  category.selected = true
  category.open = true
  category.types.forEach(
    type => {
      type.selected = true
    }
  )
}
// Need to go a little deeper on this because of the fake commercial I pushed
export function extractFilters (categories) {
  const selected = []
  categories.forEach(category => {
    category.subCats.forEach(subcat => {
      subcat.types.forEach(type => {
        if (type.selected) {
          selected.push(type.id)
        }
      })
    })
  })
  return selected
}
export function extractCommercialFilters (categories) {
  const selected = []
  categories.forEach(category => {
    category.types.forEach(type => {
      if (type.selected) {
        selected.push(type.id)
      }
    })
  })
  return selected
}
export function countAssetsByDistrict (communityAssets, districtCentroids) {
  // Counting the occurencies for each different districtID in the communityAssets
  // TODO : Tell the PO that the column in CA needs to be named : districtID
  const communityAssetsSummary = communityAssets.features.reduce((newObj, obj) => {
    // console.log(newObj, obj)
    if (newObj[obj.properties.districtid]) {
      newObj[obj.properties.districtid] = newObj[obj.properties.districtid] + 1
    } else {
      newObj[obj.properties.districtid] = 1
    }
    return newObj
  }, {})
  // Extracting the keys
  const districtId = Object.keys(communityAssetsSummary)
  // Adding a qty properties to the centroids ...
  // ... reflecting the reduce by districtID made on the communityAssets
  districtCentroids.features.map(centroid => {
    districtId.map(id => {
      if (centroid.properties.CODEID === id) {
        centroid.properties.qty = communityAssetsSummary[id]
      }
    })
  })
  districtCentroids.features.map(feature => {
    if (feature.properties.qty === undefined) {
      feature.properties.qty = 0
    }
  })
  return districtCentroids
}
